
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ComponentBase, TypeCategoryInfo } from 't4core';
import { T4DatatableWidget } from '../../../../t4common';
import { EditCategoryDialog } from '../../dialogs/EditCategoryDialog/EditCategoryDialog';
@Component({
  styleUrls: ['./ManageCategories.css'],
  selector: 't4-ManageCategories',
  templateUrl: './ManageCategories.component.html',
})
export class ManageCategoriesComponent extends ComponentBase implements OnInit {
  public myCategories: TypeCategoryInfo[];
  public inheritedCategories: TypeCategoryInfo[];

  @ViewChild("tblCategories")
  private tblCategories: T4DatatableWidget;
  @ViewChild("tblInherited")
  private tblInherited: T4DatatableWidget;

  constructor(el: ElementRef, private router: Router) {
      super();
    }

  async ngOnInit() {
      await this.LoadCategories();
  }

  private async LoadCategories() {
    var token = this.UI.beginLoading("T4.Settings.ManageCategories.msgLoading", "Loading categories", null);
    this.myCategories = null;
    this.inheritedCategories = null;

    var ret = await this.Api.get<TypeCategoryInfo[]>("RentalObject/GetTypeCategoriesForEdit");

    if (ret[0].ContextId == this.Settings.clientSettings.ContextId) this.myCategories = ret;
    else this.inheritedCategories = ret;

    if (this.tblCategories) this.tblCategories.update();
    if (this.tblInherited) this.tblInherited.update();
    this.UI.loaderCompleted(token);
  }

  public openCategory(cat: TypeCategoryInfo) {
    EditCategoryDialog.open(this.Dialog, cat);
  }

  public async deleteCategory(row: TypeCategoryInfo) {
    if (await this.UI.confirm("T4.Settings.ManageCategories.headConfirmRemove", "Confirm deletion", "T4.Settings.ManageCategories.msgConfirmRemove", "Are you sure you want to delete this category?")) {
      await this.Api.delete("RentalObject/DeleteCategory", { categoryId: row.Id})

      this.LoadCategories();
    }
  }


  public async createCategory() {
    await EditCategoryDialog.open(this.Dialog, null);
    this.LoadCategories();
  }
}
